import { IBackendCartEntries, ICartEntry } from '@rbi-ctg/menu';
import { ICartEntryFragment } from 'generated/rbi-graphql';
import { useLocationContext } from 'state/location';
import { useOrderContext } from 'state/order';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

interface UseAddToCartProps {
  cartEntry: ICartEntry | IBackendCartEntries | ICartEntryFragment | null;
}

const useAddToCartRecentItem = ({ cartEntry }: UseAddToCartProps) => {
  const { location, setStoreLocatorCallbackUrl, navigate } = useLocationContext();
  const {
    addToCart: addItemToCart,
    recent: {
      setPendingRecentItem,
      pendingRecentItemNeedsReprice,
      setPendingRecentItemNeedsReprice,
    },
    repriceCartEntries,
  } = useOrderContext();
  const { isStoreOpenAndAvailable } = useStoreContext();

  const handleAddToCart = () => {
    if (isStoreOpenAndAvailable) {
      // If you had no store selected previously the prices on the cartEntry are zero
      // This will repair the prices before adding to cart
      if (pendingRecentItemNeedsReprice) {
        const [repricedEntry] = repriceCartEntries([cartEntry]);
        addItemToCart(repricedEntry);
        setPendingRecentItemNeedsReprice(false);
      } else {
        addItemToCart(cartEntry);
      }
    } else {
      setPendingRecentItem(cartEntry);
      setPendingRecentItemNeedsReprice(true);
      setStoreLocatorCallbackUrl(location.pathname);
      navigate(routes.storeLocator);
    }
  };

  const addToCart = () => {
    handleAddToCart();
  };

  return {
    addToCart,
  };
};

export default useAddToCartRecentItem;
